<eo-modal
  [header]="'MAKE_A_CHOICE' | translate"
  [displayButton]="false"
  cancelPosition="above-right">
  <method-grid
    template="grid"
    (dismissed)="dismiss($event)">
  </method-grid>
</eo-modal>
